import * as React from "react"
import PageNumberButton from "./PageNumberButton"
import ButtonGroup from "@material-ui/core/ButtonGroup"
import Button from "@material-ui/core/Button"
import {withStyles} from "@material-ui/styles"
import "./Pagination.scss"

//PageTextButton is customized material ui button for First and Last page

const PageTextButton = withStyles({
  root: {
    height: "var(--action-item-height)",
    minWidth: 60,
    color: "var(--modes-on-primary-container)",
    fontWeight: "var(--font-weight-semibold)",
    fontSize: "var(--font-size-paragraph-large)",
    padding: 0,
    margin: "0px 12px",
    marginRight: "12px",
    borderRadius: "var(--border-radius)",
    border: "1px solid var(--modes-primary)",
    backgroundColor: "var(--modes-background)",

    "&:hover": {
      backgroundColor: "transparent",
      color: "var(--color-primitives-evergreen-evergreen30)",
    },
  },
})(Button)
/*
  Pagination Component
  @param {string} totalPages
  @param {string} activeIndex
  @param {func} onChange
  @returns pagination component
 */

const Pagination = ({activeIndex, totalPages, onPageChange}) => {
  let pages = []
  let isFirstPageActive = activeIndex === 0
  let isLastPageActive = activeIndex === totalPages - 1 || totalPages === 0

  function changeActivePage(indexTo) {
    if (indexTo >= 0 && indexTo < totalPages) {
      onPageChange(indexTo)
    }
  }

  //conditional rendering of PageNumberButtons as { pages }  based on the activeIndex and the totalPages

  if (totalPages < activeIndex) {
    return <></>
  } else {
    let section = Math.floor(activeIndex / 3) //here 5 is the maximum number of pages displayed at a time.
    for (let index = 0; index < 3; index++) {
      let indexNumber = section * 3 + index
      if (indexNumber >= totalPages) break
      if (indexNumber === activeIndex) {
        pages.push(
          <PageNumberButton key={indexNumber} variant="contained" color="secondary">
            {indexNumber + 1}
          </PageNumberButton>
        )
      } else {
        pages.push(
          <PageNumberButton
            key={indexNumber}
            onClick={() => {
              changeActivePage(indexNumber)
            }}
          >
            {indexNumber + 1}
          </PageNumberButton>
        )
      }
    }
    let nextSectionFirstIndex = (section + 1) * 3
    let previousSectionFirstIndex = (section - 1) * 3
    if (nextSectionFirstIndex + 1 <= totalPages) {
      pages.push(
        <PageNumberButton
          key="previousSection"
          onClick={() => {
            changeActivePage(nextSectionFirstIndex)
          }}
        >
          ...
        </PageNumberButton>
      )
    }
    if (previousSectionFirstIndex >= 0) {
      pages.unshift(
        <PageNumberButton
          key="nextSection"
          onClick={() => {
            changeActivePage(previousSectionFirstIndex)
          }}
        >
          ...
        </PageNumberButton>
      )
    }
  }

  return (
    <div className="pagination-buttons">
      <PageTextButton
        key="firstPage"
        onClick={() => {
          !isFirstPageActive && changeActivePage(0)
        }}
        disabled={isFirstPageActive}
      >
        First
      </PageTextButton>

      <ButtonGroup size="small">
        <PageNumberButton
          key="previousPage"
          onClick={() => {
            !isFirstPageActive && changeActivePage(activeIndex - 1)
          }}
          disabled={isFirstPageActive}
        >
          &#60;
        </PageNumberButton>

        {pages}

        <PageNumberButton
          key="nextPage"
          onClick={() => {
            !isLastPageActive && changeActivePage(activeIndex + 1)
          }}
          disabled={isLastPageActive}
        >
          &#62;
        </PageNumberButton>
      </ButtonGroup>
      <PageTextButton
        key="lastPage"
        onClick={() => {
          !isLastPageActive && changeActivePage(totalPages - 1)
        }}
        disabled={isLastPageActive}
      >
        Last
      </PageTextButton>
    </div>
  )
}
export default Pagination
